"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = [{
  name: 'Australia',
  code: 'AU'
}, {
  name: 'Canada',
  code: 'CA'
}, {
  name: 'Portugal',
  code: 'PT'
}, {
  name: 'United Kingdom',
  code: 'GB'
}, {
  name: 'United States',
  code: 'US'
}, {
  name: 'Ireland',
  code: 'IE'
}];
exports.default = _default;